import { all } from "redux-saga/effects";
import { watchJoinSaga } from "./joinSaga";
import { watchGameDashboardCardCreateSaga } from "./game_dashboard_card_create_saga";

function* RootSaga() {
  yield all([
    watchJoinSaga(),
    watchGameDashboardCardCreateSaga()
  ]);
}

export default RootSaga;
